import React from 'react'
import PromoBadge from '../components/common/Badge/PromoBadge'

import { formatCurrency } from '../../miscellaneous/helpers/utils';

import '../Merchant/Merchant.css'

const ItemResult = ({item, detailFunction, compact = false}) => {
    return (
        <div className={`explore-result-container ${compact ? 'explore-result-container-compact' : ''}`}>
            <div className="merchant-menu-list-card">
                <div className="merchant-menu-list">
                    <div className="img-container">
                        <img src={item.image} className="merchant-menu-img" loading="lazy" alt="" />
                    </div>
                    <div className="merchant-menu-list-detail">
                        <span className="merchant-menu-list-detail-name">{item.name}</span>
                        {item.discount === 1 ? <span className="merchant-menu-list-detail-discounted">{formatCurrency(item.total)}</span> : ''}
                        <span className="merchant-menu-list-detail-price">{item.discount === 1 ? <><s>{formatCurrency(item.price)}</s><PromoBadge /></> : formatCurrency(item.price)}</span>
                        {!compact ? <span className="explore-result-merchant-name-text">By <span id="orange-color">{item.merchants?.name}</span></span> : null}
                        <span className="explore-by-text"></span>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default React.memo(ItemResult)
